import {Component, Input, OnInit} from '@angular/core';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-card-chart-intensity',
  templateUrl: './card-chart-intensity.component.html',
  styleUrls: ['./card-chart-intensity.component.scss']
})
export class CardChartIntensityComponent implements OnInit {

  @Input() data: [];

  chartOptions: {};
  Highcharts = Highcharts;

  defaultVisible: boolean;

  constructor() {
    this.defaultVisible = false;
  }

  toggleDefault() {
    this.defaultVisible = !this.defaultVisible;
  }

  ngOnInit(): void {
    this.chartOptions = {
      chart: {
        type: 'scatter',
        zoomType: 'xy',
        backgroundColor: null
      },
      title: {
        text: null
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false
      },
      xAxis: {
        title: {
          enabled: true,
          text: 'Effective Number of Factors'
        },
        min: 0,
        lineWidth: 0,
        minorGridLineWidth: 0,
        lineColor: 'transparent',
        labels: {
          enabled: true
        },
        minorTickLength: 0,
        tickLength: 0
      },
      yAxis: {
        title: {
          text: null
        },
        min: 0,
        gridLineDashStyle: "Dash",
        gridLineColor: 'grey'
      },
      legend: false,
      tooltip: {
        useHTML: true,
        formatter: function () {
          return '<strong>' + this.point.name + '</strong>:'+
                 '<br> - ENF: ' + this.point.x.toFixed(2) +
                 '<br> - Intensity: ' + this.point.y.toFixed(2);
        },
        style: {
          color: 'rgb(118,168,255)',
        }
      },
      plotOptions: {
        scatter: {
          allowPointSelect: true,
          marker: {
            radius: 5,
            states: {
              select: {
                radius: 7
              }
            }
          }
        }
      },
      series: [{
        name: 'Factor Intensity',
        color: 'rgb(118,168,255)',
        data: this.data
      }]
    };
  }

}
